import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { DataDispatchChannelEnum } from '../../../shared/modules/data-dispatch/enums/data-dispatch-channel.enum';
import { OutboxStatusEnum } from '../enums/outbox-status.enum';
import { OutboxTypeEnum } from '../enums/outbox-type.enum';

/**
 * Lease outbox record DTO
 */
export class LeaseOutboxRecordDto {
	tenantOrgId!: string;
	id!: number;
	tenantId!: number;
	tenantName?: string;
	tenantStatus?: string;
	userId!: number;
	type!: OutboxTypeEnum;
	channel?: DataDispatchChannelEnum;
	status!: OutboxStatusEnum;
	key!: string;
	context?: Record<string, any>;
	subject!: AppSubjectEnum;
	subjectId!: number;
	dispatchToken!: string;
	retryCount!: number;
	nextRetryAt?: Date;
	scheduledAt?: Date;
	leasedBy?: string;
	leasedUntil?: Date;
	dispatchedAt?: Date;
	dispatchError?: string;
	createdAt!: Date;
	updatedAt!: Date;

	/**
	 * User email address
	 */
	userEmail?: string;

	/**
	 * User mobile phone number
	 */
	userMobilePhone?: string;

	/**
	 * Audit log ID (if the notification was triggered by an audit event)
	 */
	auditLogId?: number;

	/**
	 * Generated email template subject (populated during lease for email channel)
	 */
	templateSubject?: string;

	/**
	 * Generated email template HTML body (populated during lease for email channel)
	 */
	templateHtmlBody?: string;

	/**
	 * Generated plain text for SMS (populated during lease for SMS channel)
	 */
	templateTextBody?: string;
}
